/**
 * Toast notification system.
 * Creates temporary alert toasts in the #toast-container element.
 */

const TOAST_DURATION_MS = 3000;
const FADE_OUT_MS = 300;

type ToastType = 'success' | 'error' | 'info';

/**
 * Show a toast notification.
 * @param message - The message to display
 * @param type - 'success' | 'error' | 'info'
 */
export function showToast(message: string, type: ToastType = 'success'): void {
    const container = document.getElementById('toast-container');
    if (!container) return;

    const toast = document.createElement('div');

    const bgColor = type === 'success' ? 'bg-emerald text-black' :
                   type === 'error' ? 'bg-accent text-white' :
                   'bg-neutral text-neutral-content';
    const icon = type === 'success' ? 'ph-check-circle' :
                type === 'error' ? 'ph-warning-circle' :
                'ph-info';

    toast.className = `alert ${bgColor} shadow-lg flex items-center gap-2 px-4 py-3 rounded-xl min-w-0`;
    toast.setAttribute('role', 'alert');
    toast.innerHTML = `<i class="ph-fill ${icon} text-lg shrink-0" aria-hidden="true"></i><span class="text-sm font-medium">${message}</span>`;
    container.appendChild(toast);

    setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transition = `opacity ${FADE_OUT_MS / 1000}s ease-out`;
        setTimeout(() => toast.remove(), FADE_OUT_MS);
    }, TOAST_DURATION_MS);
}
